<template>
  <div class="app-shell position-relative">
    <div class="loading-overlay" v-if="userStore.loading">
      <VueSpinner size="50" color="#1B6C97" />
    </div>
    <div class="wrapper" v-if="authReady && isLoggedIn && !isPublicLanding">
      <Navbar :is-mobile="isMobile" @toggleSidebar="sidebarOpen = !sidebarOpen"/>
      <div class="content-wrapper d-flex">
        <Sidebar @closeSidebar="sidebarOpen = false" :is-mobile="isMobile" :open="sidebarOpen"/>
        <div class="content" v-if="isDataFetched && bootstrapReady">
          <div class="container-fluid position-relative app-content-shell">
            <router-view/>
          </div>
        </div>
      </div>
      <Footer />
    </div>
    <div class="wrapper bg-blue" v-else>
      <router-view/>
    </div>
  </div>
</template>

<script>
import {CheckBreakpoint} from "./scripts/tools";
import {useUserStore} from "./stores/user";
import Sidebar from "./components/layout/Sidebar"
import Footer from "./components/layout/Footer"
import Navbar from "./components/layout/Navbar"
import { VueSpinner } from 'vue3-spinners';
export default {
  components: {
    Sidebar,
    Footer,
    Navbar,
    VueSpinner,
  },
  setup() {
    return {
      userStore: useUserStore(),
    }
  },
  name: "App",
  data() {
    return {
      sidebarOpen: true,
      isMobile: false,
      bootstrapReady: false,
    }
  },
  mounted() {
    CheckBreakpoint.init()
    this.checkBreakpoint()
    window.addEventListener('resize', this.checkBreakpoint);
  },
  unmounted() {
    window.removeEventListener('resize', this.checkBreakpoint);
  },
  methods: {
    logout(e) {
      e.preventDefault()
      //TODO Logout
    },
    checkBreakpoint() {
      this.sidebarOpen = !CheckBreakpoint.checkSmaller('lg');
      this.isMobile = CheckBreakpoint.checkSmaller('lg');
    },
  },
    computed: {
    authReady() {
      return this.userStore.authReady;
    },
    isLoggedIn() {
      return this.userStore.hasActiveSession;
    },
    isPublicLanding() {
      return this.$route.meta.publicLanding === true;
    },
    isDataFetched() {
      return this.userStore.user.isDataFetched;
    }
  },
  async created() {
    await this.userStore.initializeAuth()
    this.bootstrapReady = true
  }
}
</script>
<style lang="scss">
.app-shell {
  min-height: 100vh;
}

.loading-overlay {
  background: rgba(8, 26, 40, 0.36);
  backdrop-filter: blur(10px);
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  margin-inline: auto;
  z-index: 99;

  display: flex;
  justify-content: center;
  align-items: center;
}

.app-content-shell {
  position: relative;
  z-index: 1;
}
</style>
